<template>
<!-- 题目管理 弹窗：批量导入题目 -->
    <el-dialog title="设置填空" :visible.sync="dialogVisible" width="500px" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="form" ref="form" label-width="70px">
            <el-form-item v-for="(e, i) in form.value" :label="'答案' + (i+1)" :key="i">
                <el-input v-model="form.value[i]" style="width:82%" maxlength="200" show-word-limit clearable></el-input>
                <el-button @click="remove" v-if="form.value.length > 1" type="danger" plain icon="el-icon-minus" circle style="margin-left:10px"></el-button>
            </el-form-item>
            <el-form-item>
                <el-button @click="add" type="primary" plain>新增答案</el-button>
            </el-form-item>
            <p style="margin:-20px 0 0 70px">点击新增答案，可为一个填空项设置多个答案</p>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submitForm('form')">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: ['show'],
    data() {
        return {
            dialogVisible: false,
            form: {
                value: ['']
            },
            submit: false
        };
    },
    watch: {
        show() {
            this.submit = false
            this.dialogVisible = this.show;
        }
    },
    methods: {      
        submitForm(formName) {
            let error = false
            for (let i = 0; i < this.form.value.length; i++) {
                const e = this.form.value[i];
                if (!e) {
                    error = true
                }
            }
            if (error) {
                this.$message({
                    message: '填空答案不能为空',
                    type: 'error'
                });
            }else {
                this.dialogVisible = false
                this.submit = true
            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        remove(i) {
            // var index = this.form.value.indexOf(item)
            // if (index !== -1) {
            this.form.value.splice(i, 1)
            // }
        },
        add() {
            this.form.value.push('');
        },
        close() {
            var data = this.form.value.join("|")
            this.form.value = ['']
            if (this.submit) {
                // this.$emit('close', '<span class="questionblankTag">[['+data+']]</span>', data.length)
                this.$emit('close', '[['+data+']]', data.length)
            }else {
                this.$emit('close', false)
            }
        },
    }
};
</script>

<style>
    .el-upload, .el-upload-dragger {
        width: 100%;
    }
    .pai .el-dialog .el-dialog__body{
        padding: 0;
    }
</style>